var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("stepheader", { attrs: { step: _vm.step } }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "body current",
          attrs: {
            id: "wizard2-p-0",
            role: "tabpanel",
            "aria-labelledby": "wizard2-h-0",
            "aria-hidden": "false",
          },
        },
        [
          _vm.isloading
            ? _c("div", { staticClass: "row" }, [_vm._m(0)])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isloading
            ? _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12" }, [
                  _vm._v(
                    "\n        Verrà aperto un ticket per risolvere il tuo problema."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        Il nostro backoffice verificherà la tua segnalazione e ti indicherà le istruzioni attraverso il ticket\n        aperto."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n        Ti ricordiamo che tutte le comunicazioni saranno inviate all'interno del ticket che troverai nella tua area\n        riservata\n        "
                  ),
                  _vm.ticket.cliente
                    ? _c("span", [
                        _vm._v(
                          "La mail associata al tuo contratto è\n          "
                        ),
                        _c("strong", [
                          _vm._v(_vm._s(_vm.ticket.cliente.emailOperativa)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v("\n        Daremo al corriere l'indirizzo email "),
                  _c("strong", [_vm._v(_vm._s(_vm.indirizzo.email))]),
                  _vm._v(" e il telefono\n        "),
                  _c("strong", [_vm._v(_vm._s(_vm.indirizzo.telefono))]),
                  _vm._v(
                    " per contattarti in caso di necessità durante la consegna del device\n\n      "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isloading
            ? _c("buttons", {
                attrs: { buttons: _vm.step.buttons },
                on: { action: _vm.fireaction },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("span", {
        staticClass: "spinner-grow spinner-grow-sm",
        attrs: { role: "status", "aria-hidden": "true" },
      }),
      _vm._v("\n          Caricamento in corso\n      "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }